module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/option-1-e397319242a8531e36c8e442c17509c0.png";